import { createSelector } from 'reselect'

import { selectContactsState } from './selectContactsState'

export const selectContactsFilters = createSelector([selectContactsState], (state) => ({
  partnerId: state.partnerId,
  programType: state.programType,
}))
